export default "__VITE_ASSET__CSLI5xn0__"